import { render, staticRenderFns } from "./CBFloor.vue?vue&type=template&id=6d15b032&"
import script from "./CBFloor.vue?vue&type=script&lang=js&"
export * from "./CBFloor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports